import { useAtom } from 'jotai';
import type {
  DeviceTypes,
  OrganizationMemberConfig,
  SubscriptionTypes,
} from 'src/api/endpoints/testDataApi.types';
import { atomWithLocalStorage } from 'src/utils/atomWithLocalStorage';

export type GeneratedTestUser = {
  username: string;
  password?: string;
  devices: DeviceTypes[];
  subscription: SubscriptionTypes | null;
  organization: OrganizationMemberConfig | null;
  actAsExternalUser: boolean;
  createdAt: string;
};

const generatedTestUsers = atomWithLocalStorage<GeneratedTestUser[]>(
  'generatedTestUsers',
  []
);

export const useGeneratedTestUsers = () => {
  const [generatedUsers, setGeneratedUsers] = useAtom(generatedTestUsers);

  function add(user: GeneratedTestUser) {
    setGeneratedUsers([...generatedUsers, user]);
  }

  function remove(user: GeneratedTestUser) {
    setGeneratedUsers(
      generatedUsers.filter((u) => u.username !== user.username)
    );
  }

  function clear() {
    setGeneratedUsers([]);
  }

  return {
    data: generatedUsers,
    add,
    remove,
    clear,
  };
};
